import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error?.message || '알 수 없는 오류' };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // 에러 로깅 (필요시 서비스로 전송 가능)
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0d1f3c 0%, #152a52 60%, #111e3a 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
          }}
        >
          <div style={{ textAlign: 'center', maxWidth: '400px', width: '100%' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🏡</div>
            <div style={{ color: '#c9a227', fontSize: '18px', fontWeight: 700, marginBottom: '8px' }}>
              홈 &amp; 그레이브
            </div>
            <p style={{ color: 'rgba(200,216,240,0.7)', fontSize: '14px', lineHeight: 1.6, marginBottom: '16px' }}>
              페이지를 불러오는 중 문제가 발생했습니다.
              <br />
              새로고침 후 다시 시도해주세요.
            </p>
            {/* 에러 메시지 표시 (진단용) */}
            {this.state.errorMessage && (
              <div style={{
                background: 'rgba(255,0,0,0.1)',
                border: '1px solid rgba(255,100,100,0.3)',
                borderRadius: '8px',
                padding: '10px 14px',
                marginBottom: '20px',
                textAlign: 'left',
              }}>
                <p style={{ color: 'rgba(255,150,150,0.9)', fontSize: '11px', fontFamily: 'monospace', wordBreak: 'break-all', margin: 0 }}>
                  {this.state.errorMessage}
                </p>
              </div>
            )}
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 32px',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #c9a227, #b8860b)',
                color: '#0d1f3c',
                fontWeight: 700,
                fontSize: '15px',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              새로고침
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
